require("jquery-ui/ui/widgets/autocomplete.js");
function PropertyAutoComplete() {

    $("#propertySearch").autocomplete({
        minLength: 3,
        source: function (request, response) {
            $.ajax({
                url: "propertySearch",
                type: "POST",
                dataType: "json",
                data: { propertySearch: request.term },
                success: function (data) {
                    $("#RelatedProperty").val('0');
                    response($.map(data, function (item) {
                        return { label: item.name, value: item.propertyId };
                    }))
                }
            })
        },
        select: function (event, ui) {
            $("#RelatedProperty").val(ui.item.value);
            $("#propertySearch").val(ui.item.label);

            PopulateLocationDropdown(ui.item.value);
            return false;
        }
    });

    $("#landlordSearch").autocomplete({
        minLength: 3,
        source: function (request, response) {
            $.ajax({
                url: "landlordSearch",
                type: "POST",
                dataType: "json",
                data: { landlordSearch: request.term },
                success: function (data) {
                    $("#LandlordContact").val('0');
                    response($.map(data, function (item) {
                        return { label: item.name, value: item.contactId };
                    }))
                }
            })
        },
        select: function (event, ui) {
            $("#LandlordContact").val(ui.item.value);
            $("#landlordSearch").val(ui.item.label);
            return false;
        }
    });

    $("#landlordCompanySearch").autocomplete({
        minLength: 3,
        source: function (request, response) {
            $.ajax({
                url: "landlordCompanySearch",
                type: "POST",
                dataType: "json",
                data: { landlordCompanySearch: request.term },
                success: function (data) {
                    $("#LandlordCompany").val('0');
                    response($.map(data, function (item) {
                        return { label: item.name, value: item.companyId };
                    }))
                }
            })
        },
        select: function (event, ui) {
            $("#LandlordCompany").val(ui.item.value);
            $("#landlordCompanySearch").val(ui.item.label);
            return false;
        }
    });


    var propertyid = $("#RelatedProperty").val();
    var locationid = $("#LocationID").val();
    var RecordId = $("#LocationID").val();

    if (RecordId != 0 && RecordId != '') {
        $("#RecordRef").attr('readonly', true);
    }


    if (propertyid != 0) {
        PopulateLocationDropdown(propertyid, locationid);
    }

    function toggleLandlordDivs() {
        const selectedType = parseInt($('#LandlordType').val());

        if (selectedType === 1) {
            $('#LandlordContactDiv').show();
            $('#LandlordOrganisationDiv').hide();
        } else if (selectedType === 2) {
            $('#LandlordContactDiv').hide();
            $('#LandlordOrganisationDiv').show();
        } else {
            $('#LandlordContactDiv').hide();
            $('#LandlordOrganisationDiv').hide();
        }
    }

    $(function () {
        toggleLandlordDivs();
        $('#LandlordType').on('change', function () {
            toggleLandlordDivs();
        });
    });

    function PopulateLocationDropdown(propId, locId) {

        $.ajax({
            type: "GET",
            url: "LocationFilter",
            data: { propertyId: propId },
            success: function (data) {
                var s = '<option value="0">Please Select a Location</option>';
                for (var i = 0; i < data.length; i++) {
                    s += '<option value="' + data[i].id + '">' + data[i].path + '</option>';
                }
                $("#locationsDropdown").html(s);
                if (locId != 0 && locId != "") {
                    $('#locationsDropdown option[value="' + locId + '"]').attr("selected", "selected");
                }
            }
        });

    }

}

module.exports = PropertyAutoComplete;
